
import { DataType } from "@dndModels/Types";
import { PlayerObject } from "@models";

export class CharacterDrawnCard extends PlayerObject {
  data_type: DataType = "character_drawn_card";
  char_id = ""; 
  card_id = ""; 
  drawn_dt = 0;
  details = "";

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.char_id = obj.char_id ? obj.char_id : "";
      this.card_id = obj.card_id ? obj.card_id : "";
      this.drawn_dt = obj.drawn_dt ? obj.drawn_dt : 0;
      this.details = obj.details ? obj.details : "";
    }
  }

  toDBObj(): any {
    return {
      ...super.toDBObj(),
      char_id: this.char_id,
      card_id: this.card_id,  
      drawn_dt: this.drawn_dt,
      details: this.details,
    };
  }

  clone(): CharacterDrawnCard {
    const clone = new CharacterDrawnCard();
    clone.copy(this);
    return clone;
  }

  copy(copyMe: CharacterDrawnCard): void {
    super.copy(copyMe);
    this.char_id = copyMe.char_id;
    this.card_id = copyMe.card_id;
    this.drawn_dt = copyMe.drawn_dt;
    this.details = copyMe.details;
  }
}